import { render } from "./AuthOfficialBusinessDetails.vue?vue&type=template&id=8e1d4460&scoped=true"
import script from "./AuthOfficialBusinessDetails.vue?vue&type=script&lang=js"
export * from "./AuthOfficialBusinessDetails.vue?vue&type=script&lang=js"

import "./AuthOfficialBusinessDetails.vue?vue&type=style&index=0&id=8e1d4460&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1d4460"]])

export default __exports__